/* ============================================================
   Clown.art — Product hero gallery
   Swap main image when user clicks a thumbnail.
   Reads data-full-src / data-full-srcset / data-full-sizes / data-full-alt
   from the thumb button, applies to the main <img>.

   Strategy : event delegation on document. Catches clicks even if the
   thumbnail's inner <img> is the actual event.target (closest() walks up).
   ============================================================ */

(function () {
  'use strict';

  function init() {
    const galleries = document.querySelectorAll('[data-clown-product-gallery]');
    if (galleries.length === 0) {
      console.debug('[clown-gallery] No [data-clown-product-gallery] found on page.');
      return;
    }
    console.debug('[clown-gallery] Found', galleries.length, 'gallery wrapper(s).');
    galleries.forEach(initTrack);
  }

  function handleClick(e) {
    const btn = e.target.closest('[data-clown-gallery-thumb]');
    if (!btn) return;

    e.preventDefault();

    const wrapper = btn.closest('[data-clown-product-gallery]');
    if (!wrapper) {
      console.warn('[clown-gallery] No [data-clown-product-gallery] ancestor found for clicked thumb.');
      return;
    }

    const mainImg = wrapper.querySelector('.clown-product-hero__image--main');
    if (!mainImg) {
      console.warn('[clown-gallery] No .clown-product-hero__image--main found inside gallery wrapper.');
      return;
    }
    if (mainImg.tagName !== 'IMG') {
      console.warn('[clown-gallery] .clown-product-hero__image--main is not an <img>:', mainImg.tagName);
      return;
    }

    const newSrc = btn.getAttribute('data-full-src');
    const newSrcset = btn.getAttribute('data-full-srcset');
    const newSizes = btn.getAttribute('data-full-sizes');
    const newAlt = btn.getAttribute('data-full-alt');

    if (!newSrc && !newSrcset) {
      console.warn('[clown-gallery] Clicked thumb has no data-full-src/srcset attributes.');
      return;
    }

    /* Set srcset FIRST so browser picks the right candidate when src is updated. */
    if (newSrcset) mainImg.setAttribute('srcset', newSrcset);
    if (newSizes) mainImg.setAttribute('sizes', newSizes);
    if (newSrc) mainImg.setAttribute('src', newSrc);
    if (newAlt) mainImg.setAttribute('alt', newAlt);

    /* Sync the lightbox trigger so it opens on the currently-displayed image. */
    const trigger = wrapper.querySelector('.clown-product-hero__main-trigger[data-clown-lightbox]');
    if (trigger) {
      if (newSrc) trigger.setAttribute('data-full-src', newSrc);
      if (newSrcset) trigger.setAttribute('data-full-srcset', newSrcset);
      if (newSizes) trigger.setAttribute('data-full-sizes', newSizes);
      if (newAlt) trigger.setAttribute('data-full-alt', newAlt);
    }

    wrapper.querySelectorAll('[data-clown-gallery-thumb]').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    /* Piste défilante mobile : amener la slide correspondante en vue.
       Absente en desktop (ou si l'option est décochée) → no-op. */
    scrollTrackToMedia(wrapper, btn.getAttribute('data-media-id'));
  }

  /* ----------------------------------------------------------------
     Synchronisation piste ↔ vignettes (galerie mobile).
     La piste et la colonne de vignettes montrent le même média : un
     clic sur une vignette fait défiler la piste, et le défilement de
     la piste met à jour la vignette active.
     ---------------------------------------------------------------- */

  function scrollTrackToMedia(wrapper, mediaId) {
    if (!mediaId) return;
    const track = wrapper.querySelector('[data-clown-swipe-track]');
    if (!track) return;
    const slide = track.querySelector('[data-clown-swipe-slide][data-media-id="' + mediaId + '"]');
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function markThumbActive(wrapper, mediaId) {
    const thumbs = wrapper.querySelectorAll('[data-clown-gallery-thumb]');
    thumbs.forEach(function (b) {
      const match = b.getAttribute('data-media-id') === mediaId;
      b.classList.toggle('is-active', match);
      b.setAttribute('aria-pressed', match ? 'true' : 'false');
      /* Garder la vignette active visible dans sa colonne défilante. */
      if (match && typeof b.scrollIntoView === 'function') {
        b.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function initTrack(wrapper) {
    const track = wrapper.querySelector('[data-clown-swipe-track]');
    if (!track) return;

    let ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        /* Slide dont le bord gauche est le plus proche du bord de piste. */
        const slides = track.querySelectorAll('[data-clown-swipe-slide]');
        let best = null;
        let bestDist = Infinity;
        slides.forEach(function (sl) {
          const dist = Math.abs(sl.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = sl; }
        });
        if (best) markThumbActive(wrapper, best.getAttribute('data-media-id'));
      });
    }, { passive: true });
  }

  document.addEventListener('click', handleClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
